import {z} from "zod";


export const UiComponentBaseSchema = z.object({
    id: z.string(),
    componentType: z.string(),
});

export const UiComponentSchema: z.ZodType<any> = z.lazy(() => {
    const {GridItemSchema, GridLayoutContainerSchema} = require("./GridLayoutContainer");
    const {UiFieldSchema} = require("./UiField");
    const {UiReferenceFieldSchema} = require("./UiReferenceField");
    
    return z.union([
        UiFieldSchema,
        UiReferenceFieldSchema,
        GridItemSchema,
        GridLayoutContainerSchema,
    ]);
});

export type UiComponent = z.infer<typeof UiComponentSchema>;
